import { Component, ElementRef, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirmation-dialog',
  templateUrl: './generic-confirmation-dialog.component.html',
  styleUrl: './generic-confirmation-dialog.component.scss'
})
export class GenericConfirmationDialogComponent {

  

  constructor(
    public _dialogRef: MatDialogRef<GenericConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDdialogData,
  ) 
    {
      if(this.data.button == '')
        this.data.button = 'Submit';
      }
}

export interface IDdialogData{
  title: string;
  line1: string;
  line2: string;
  button: string;
}
